module.exports = __webpack_public_path__ + "static/media/money.138f4b68.svg";